import { useEffect } from "react";
import PropTypes from "prop-types";
import { InputSelect } from "../../../../components/formComponents/inputSelect";
import { InputFecha } from "../../../../components/formComponents/InputFecha";
import ErrorInput from "../../../../components/ui/ErrorInput";
import { useEditarDesvinculacion } from "./useEditarDesvinculacion";
import { FIELD_LABEL_STYLE } from "../ModalEditarSolicitud";

export const EditarDesvinculacion = ({ formik, onLoadingChange }) => {
  const { motivos, cargandoMotivos } = useEditarDesvinculacion();

  useEffect(() => {
    if (onLoadingChange) {
      onLoadingChange(Boolean(cargandoMotivos));
    }
  }, [cargandoMotivos, onLoadingChange]);

  // Cascada de limpieza para Desvinculación
  useEffect(() => {
    if (!formik.values.fecha_inicio_cambio) {
      if (formik.values.id_clausula_despido) formik.setFieldValue("id_clausula_despido", "");
      if (formik.values.motivo_desvinculacion) formik.setFieldValue("motivo_desvinculacion", "");
    }
  }, [formik.values.fecha_inicio_cambio]);

  useEffect(() => {
    if (!formik.values.id_clausula_despido) {
      if (formik.values.motivo_desvinculacion) formik.setFieldValue("motivo_desvinculacion", "");
    }
  }, [formik.values.id_clausula_despido]);

  return (
    <>
      <div>
        <InputFecha formik={formik} label="FECHA DE BAJA COLABORADOR *" labelStyle={FIELD_LABEL_STYLE} id="fecha_inicio_cambio" />
      </div>

      <div>
        <InputSelect
          disabled={!formik.values.fecha_inicio_cambio}
          label="CAUSAL DE DESVINCULACIÓN *"
          labelStyle={FIELD_LABEL_STYLE}
          arr={motivos}
          id="id_clausula_despido"
          llave_texto="nombre"
          llave_valor="id"
          formik={formik}
          menuPlacement="auto"
        />
      </div>

      <div>
        <div className="d-flex flex-row justify-content-between align-items-center mb-1">
          <label htmlFor="motivo_desvinculacion" style={{ ...FIELD_LABEL_STYLE, marginBottom: 0 }}>
            JUSTIFICACIÓN DE LA SOLICITUD <span className="text-danger">*</span>
          </label>
          {formik.values.motivo_desvinculacion?.length ? (
            <span className="badge rounded-pill bg-info text-dark d-flex align-items-center">
              {300 - formik.values.motivo_desvinculacion?.length} caracteres restantes
            </span>
          ) : null}
          {formik.errors.motivo_desvinculacion !== undefined &&
            formik.touched.motivo_desvinculacion !== undefined && (
              <ErrorInput
                touched={formik.touched.motivo_desvinculacion}
                error={formik.errors.motivo_desvinculacion}
              />
            )}
        </div>
        <textarea
          disabled={!formik.values.id_clausula_despido}
          onChange={formik.handleChange}
          name="motivo_desvinculacion"
          maxLength={300}
          className="form-control"
          id="motivo_desvinculacion"
          value={formik.values.motivo_desvinculacion || ""}
          rows="3"
        />
      </div>
    </>
  );
};

EditarDesvinculacion.propTypes = {
  formik: PropTypes.object.isRequired,
  onLoadingChange: PropTypes.func,
};
